import { render } from "./UserInfoView.vue?vue&type=template&id=763e163c&scoped=true"
import script from "./UserInfoView.vue?vue&type=script&lang=js"
export * from "./UserInfoView.vue?vue&type=script&lang=js"

import "./UserInfoView.vue?vue&type=style&index=0&id=763e163c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763e163c"]])

export default __exports__